import { Menu } from "@headlessui/react";
import {
  XMarkIcon,
  EllipsisVerticalIcon,
} from "@heroicons/react/24/outline";
import React from "react";
import { NotificationContext } from "../../common/context/notification";
import { classNames } from "../../common/utils/classnames";
import {
  IdentityFragment,
  useDeleteIdentityLegacyMutation,
} from "../../graphql/generated";
import { DeleteIdentityLegacyDialog } from "./delete-dialog";
import { useNavigate } from "react-router-dom";

const IdentityActions: React.FC<{ identity?: IdentityFragment }> = ({
  identity,
}) => {
  const { notifier } = React.useContext(NotificationContext);
  const [deleteIsOpen, setDeleteIsOpen] = React.useState(false);
  const [, deleteIdentityLegacyMutation] = useDeleteIdentityLegacyMutation();
  const navigate = useNavigate();

  const deleteIdentity = React.useCallback(async () => {
    await deleteIdentityLegacyMutation({ id: identity?.id || ""}).then(
      notifier.notifyGraphql("Identity deleted")
    );
    setDeleteIsOpen(false);
    navigate("/identities")
  }, [identity?.id, deleteIdentityLegacyMutation, setDeleteIsOpen]);

  return (
    <>
      <Menu as="div" className="relative inline-block text-left mt-4 sm:mt-0">
        <div>
          <Menu.Button className="bg-gray-100 rounded-full flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500">
            <span className="sr-only">Open options</span>
            <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
          </Menu.Button>
        </div>

        <Menu.Items className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none">
          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <div
                  onClick={() => setDeleteIsOpen(true)}
                  className={classNames(
                    active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                    "group flex items-center px-4 py-2 text-sm cursor-pointer"
                  )}
                >
                  <XMarkIcon
                    className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                    aria-hidden="true"
                  />
                  Delete Identity
                </div>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Menu>
      <DeleteIdentityLegacyDialog
        identity={identity}
        isOpen={deleteIsOpen}
        onClose={() => setDeleteIsOpen(false)}
        onSubmit={() => deleteIdentity()}
      />
    </>
  );
};

export default IdentityActions;
